<header>
  <skip-nav>Skip to main content</skip-nav>
  <axis-navbar
    *ngIf="screenSize !== 'mobile'"
    class="_bg-primary _border-none"
  >
    <axis-navbar-logo>
      <a
        routerLink="/home"
        [queryParams]="{ key: requestKey }"
      >
        <img
          alt="AIG logo"
          src="assets/images/logos/aig-logo.svg"
        />
        <span class="_sr-only">American International Group, Inc.</span>
      </a>
    </axis-navbar-logo>
    <axis-navbar-app-title>
      {{ request?.requestDetails?.accountDetail?.insuredCompanyName ?? "--" }} -
      {{ request?.requestDetails?.policySelection?.contactDetailsPolicyFormType }}
      <span class="_text-italic _text-light _text-medium"></span>
    </axis-navbar-app-title>
  </axis-navbar>
  <nav
    *ngIf="screenSize === 'mobile'"
    class="axis-navbar-mobile"
    [ngClass]="{ open: navbarOpen }"
  >
    <div
      class="axis-mobile-overlay"
      (click)="closeOverlay()"
    ></div>
    <div class="axis-mobile-header">
      <div class="axis-navbar-title">
        <axis-navbar-logo>
          <a
            routerLink="/home"
            [queryParams]="{ key: requestKey }"
          >
            <img
              alt="AIG logo"
              src="assets/images/logos/aig-logo-blue.svg"
            />
            <span class="_sr-only">American International Group, Inc.</span>
          </a>
        </axis-navbar-logo>
        <axis-navbar-app-title
          >{{ request?.requestDetails?.accountDetail?.insuredCompanyName ?? "--" }} -
          {{ request?.requestDetails?.policySelection?.contactDetailsPolicyFormType }}</axis-navbar-app-title
        >
      </div>
    </div>
  </nav>
</header>
@if (router.url.includes("insured") || router.url.includes("broker")) {
  <div
    axisSticky="80"
    class="sticky-header"
  >
    <nav>
      <div class="_bg-primary">
        <div class="_p-medium">
          <div class="axis-container-fluid">
            <div
            [class.axis-show-more-wrapper]="policyCount > 1"
            [class.size-small]="policyCount > 1"
          >
            <div
              class="show-more-content _layout-column _row-gap-medium"
              [class.show-more-content-open]="showPolicyDetails"
            >
              @if (policyCount > 1 && !showPolicyDetails) {
                <div class="_text-italic">Expand to see Policy Details</div>
              }
              @if (policyCount >= 1 && showPolicyDetails) {
                <div class="_text-italic">{{policyDescription1}}</div>
              }
              <div
                aria-label="Summary of account application"
                class="axis-grid _row-gap"
                role="list"
              >
                <div
                  class="axis-col-4 axis-col-md-2 axis-col-xxl-1"
                  role="listitem"
                >
                  <div class="_text-small">Policy</div>
                  <span class="axis-h4 _nm"
                  axis-tooltip
                  axis-truncate
                  [content]="policyNumber1"
                  >{{ policyNumber1 }}</span>
                </div>
                <div
                  class="axis-col-8 axis-col-md-3"
                  role="listitem"
                >
                  <div class="_text-small">Issuing Company</div>
                  <div
                    class="axis-h4 _nm custom-truncate"
                    axis-tooltip
                    axis-truncate
                    [content]="issuingCompany1"
                    [multiLineTruncate]="true"
                    [innerHtml]="issuingCompany1"
                  ></div>
                </div>
                <div
                  class="axis-col-4 axis-col-md-auto"
                  role="listitem"
                >
                  <div class="_text-small">Policy Liability Limit</div>
                  <div class="axis-h4 _nm">${{ liabilityLimit1 | number }}</div>
                </div>
                <div
                  class="axis-col-4 axis-col-md-3 axis-col-xl-2"
                  role="listitem"
                >
                  <div class="_text-small">{{ isShowingGarageStates ? 'Garage States' : 'Covered States' }}</div>
                  <div
                    class="axis-h4 _nm custom-truncate"
                    axis-tooltip
                    axis-truncate
                    [multiLineTruncate]="true"
                    [content]="coveredStates1"
                    [innerHtml]="coveredStates1"
                  ></div>
                </div>
                <div
                  class="axis-col-4 axis-col-md-auto axis-col-xxl"
                  role="listitem"
                >
                  <div class="_text-small">Policy Eff Date</div>
                  <div
                    class="axis-h4 _nm"
                    [innerHTML]="policyEffDate1"
                  ></div>
                </div>
 
                <div
                  class="axis-col-4 axis-col-md-auto axis-col-xxl"
                  role="listitem"
                >
                  <div class="_text-small">Broker Name</div>
                  <div class="axis-h4 _nm">{{ request?.requestDetails?.accountDetail?.brokerName }}</div>
                </div>
                <div
                  class="axis-col-4 axis-col-md-2"
                  role="listitem"
                >
                  <div class="_text-small">Broker Email</div>
                  <div class="axis-h4 _nm">{{ request?.requestDetails?.accountDetail?.brokerEmail.split(",")[0] }}</div>
                </div>
              </div>
              @if (policyCount > 1) {
                <div class="_text-italic">{{policyDescription2}}</div>
                <div
                  aria-label="Summary of account application"
                  class="axis-grid _row-gap"
                  role="list"
                >
                  <div
                    class="axis-col-4 axis-col-md-2 axis-col-xxl-1"
                    role="listitem"
                  >
                    <div class="_text-small">Policy</div>
                    <span class="axis-h4 _nm"
                    axis-tooltip
                    axis-truncate
                    [content]="policyNumber2"
                    >{{ policyNumber2 }}</span>
                  </div>
                  <div
                    class="axis-col-8 axis-col-md-3"
                    role="listitem"
                  >
                    <div class="_text-small">Issuing Company</div>
                    <div
                      class="axis-h4 _nm custom-truncate"
                      axis-tooltip
                      axis-truncate
                      [content]="issuingCompany2"
                      [multiLineTruncate]="true"
                      [innerHtml]="issuingCompany2"
                    ></div>
                  </div>
                  <div
                    class="axis-col-4 axis-col-md-auto"
                    role="listitem"
                  >
                    <div class="_text-small">Policy Liability Limit</div>
                    <div class="axis-h4 _nm">${{ liabilityLimit2 | number }}</div>
                  </div>
                  <div
                    class="axis-col-4 axis-col-md-3 axis-col-xl-2"
                    role="listitem"
                  >
                    <div class="_text-small">{{ isShowingGarageStates ? 'Garage States' : 'Covered States' }}</div>
                    <div
                      class="axis-h4 _nm custom-truncate"
                      axis-tooltip
                      axis-truncate
                      [multiLineTruncate]="true"
                      [content]="coveredStates2"
                      [innerHtml]="coveredStates2"
                    ></div>
                  </div>
                  <div
                    class="axis-col-4 axis-col-md-auto axis-col-xxl"
                    role="listitem"
                  >
                    <div class="_text-small">Policy Eff Date</div>
                    <div
                      class="axis-h4 _nm"
                      [innerHTML]="policyEffDate2"
                    ></div>
                  </div>
 
                 
                
                </div>
              }
            </div>
            @if (policyCount > 1 && showPolicyDetails) {
              <div class="_text-italic _text-left _mt-medium">Close to hide Policy Details</div>
            }
            @if (policyCount > 1) {
              <button
                [attr.aria-expanded]="showPolicyDetails"
                [attr.aria-label]="showPolicyDetails ? 'Show Less' : 'Show More'"
                axis-button
                class="show-more kind-icon"
                (click)="showPolicyDetails = !showPolicyDetails"
              >
                <axis-icon
                  [class.rotate]="showPolicyDetails"
                  icon="expand_more"
                ></axis-icon>
              </button>
            }
          </div>
          </div>
        </div>
      </div>
    </nav>
    @if (this.userService.role === "broker") {
      <axis-alert class="kind-info _nmb">
        <p>
          NOTE: No changes made to this document are saved or completed on behalf of the Insured. Please make sure the
          insured completes this form and submits.
        </p>
      </axis-alert>
    }
  </div>
}

<!-- <axis-alert
  *ngIf="showAlert"
  style="margin-bottom: 0px"
  class="kind-info"
  [dismissible]="true"
>
  <p>NOTE: No changes made to this document are saved or sent...</p>
</axis-alert> -->
